import React from "react";

import Input from "@components/Input";

class Example extends React.Component {
    constructor(props) {
        super(props);
    
        this.state = {
            custom: props.customValue !== undefined && props.customValue !== null ? props.customValue : '',
        };
    
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    componentDidUpdate(prevProps) {
        // Atualizar o estado quando customValue muda nas props
        if (prevProps.customValue !== this.props.customValue) {
            this.setState({
                custom: this.props.customValue !== undefined && this.props.customValue !== null ? this.props.customValue : '',
            });
        }
    }

    handleChange(e, callback) {
        const { setCustomValue, id } = this.props;
        let value = e.target.value;
        let name = e.target.name;
        
        this.setState({
            [name]: value,
        });
    }

    handleBlur(e) {
        const { setCustomValue, id } = this.props;
        let value = e.target.value;
        
        // Se o valor for vazio ou apenas espaços, definir como string vazia
        // Se o valor for 0 ou um número, manter como número
        if (value === '' || value.trim() === '') {
            value = '';
        } else {
            const numValue = parseInt(value, 10);
            value = isNaN(numValue) ? '' : numValue;
        }
        
        this.setState({
            custom: value,
        });

        setCustomValue(value, id);
    }

    render() {
        const { custom } = this.state;

        return (
            <div>
                <Input
                    inputType={"number"}
                    name={"custom"}
                    value={custom}
                    handleChange={this.handleChange}
                    onBlur={this.handleBlur}
                    dataIdproduct={this.props.id}
                />
            </div>
        );
    }
}

export default Example;
